import {
  ADD_COLOR_SETTINGS_ITEM,
  CLEAR_COLOR_SIDEBAR,
  CLOSE_COLOR_SIDEBAR,
  CREATE_COLOR_SCHEME,
  LOAD_COLOR_SCHEME,
  OPEN_COLOR_SIDEBAR,
  REMOVE_COLOR_SETTINGS_ITEM,
  RESET_COLOR_SIDEBAR,
  SET_CURRENT_TAB_ID,
  SET_GRADIENT_VALUE,
  SET_SIDEBAR_HEADER_OPTIONS,
  UPDATE_SETTINGS_ITEM,
} from "store/constans";
import { ColorSidebarService } from "utils/services/colorSidebar.service";

export const openSidebarAC = (column) => {
  return {
    type: OPEN_COLOR_SIDEBAR,
    payload: {
      currentColumnValue: column,
      isSidebarOpen: true,
    },
  };
};

export const closeSidebarAC = () => {
  return {
    type: CLOSE_COLOR_SIDEBAR,
    payload: {
      isSidebarOpen: false,
    },
  };
};

export const setSidebarHeaderOptionsAC = (headers, tableTypes) => {
  const headerOptions = ColorSidebarService.createHeaderOptions(
    headers,
    tableTypes
  );

  return {
    type: SET_SIDEBAR_HEADER_OPTIONS,
    payload: {
      headerOptions: headerOptions,
    },
  };
};

export const addColorItemAC = (columnType) => {
  const newItem = ColorSidebarService.createColorItemSetting(columnType);

  return {
    type: ADD_COLOR_SETTINGS_ITEM,
    payload: {
      newItem: newItem,
    },
  };
};

export const updateColorItemAC = (updatedData) => {
  return {
    type: UPDATE_SETTINGS_ITEM,
    payload: {
      updatedData: updatedData,
    },
  };
};

export const deleteColorItemAC = (id) => {
  return {
    type: REMOVE_COLOR_SETTINGS_ITEM,
    payload: {
      itemId: id,
    },
  };
};

export const clearColorSideBarAC = () => {
  return {
    type: CLEAR_COLOR_SIDEBAR,
    payload: {},
  };
};

export const resetColorSideBarAC = () => {
  return {
    type: RESET_COLOR_SIDEBAR,
    payload: {},
  };
};


export const setCurrentTabIdAC = (tabId) => {
  return {
    type: SET_CURRENT_TAB_ID,
    payload: {
      currentTabId: tabId
    },
  };
};

export const setGradientValueAC = (value) => {
  return {
    type: SET_GRADIENT_VALUE,
    payload: {
      gradientData: value
    },
  };
};

export const loadColorSchemeAC = (colorScheme, isOpenSideBar) => {

  const {colorSchemeType, colorColumnKey, colorColumnType, colorSchemeGradientData, colorSchemeConditionsData} = colorScheme

  const colorSettingsItems = colorSchemeConditionsData.conditions.map((condition) => {
    const currentSetting = ColorSidebarService.createColorItemSetting(colorScheme.colorColumnType);
    const selectedOption = currentSetting.options.find((option) => option.key === condition.type);
    currentSetting.inputsDataArray = condition.inputsDataArray;
    currentSetting.color = condition.color;
    currentSetting.selectedOption = selectedOption;
    return currentSetting;
  })

  const updateColorScheme = {
    colorSchemeType,
    colorColumnKey,
    colorColumnType,
    colorSchemeGradientData,
    colorSchemeConditionsData,
  };

  const colorConditionState = {
    isSidebarOpen: isOpenSideBar,
    currentColumnValue: {
      value: "",
      key: colorColumnKey,
      type: colorColumnType,
    },
    currentTabId: colorSchemeType,
    currentColumnType: colorColumnType,
    headerOptions: [],
    gradientData: colorSchemeGradientData,
    colorSettingsItems,
    colorScheme: updateColorScheme,
  }

  return {
    type: LOAD_COLOR_SCHEME,
    payload: {
      colorConditionState
    },
  };
};

export const createColorSchemeAC = ({currentTableId,...schemeData}) => {

  const colorScheme = ColorSidebarService.createColorScheme(schemeData)

  return {
    type: CREATE_COLOR_SCHEME,
    payload: {
      colorScheme: colorScheme,
      currentTableId,
    },
  };
};
